import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;
export const http = axios.create({ baseURL: API });
export const admin = axios.create({ baseURL: API });
admin.interceptors.request.use((c) => { const t = localStorage.getItem("rv_admin"); if (t) c.headers.Authorization = `Bearer ${t}`; return c; });
admin.interceptors.response.use((r) => r, (e) => { if (e.response?.status === 401) { localStorage.removeItem("rv_admin"); window.dispatchEvent(new Event("rv-admin-out")); } return Promise.reject(e); });
export const img = (u) => (u && u.startsWith("/api/") ? BACKEND + u : u);
export const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;
export const errMsg = (e, f = "Something went wrong") => { const d = e?.response?.data?.detail; return typeof d === "string" ? d : Array.isArray(d) ? d.map((x) => x.msg).join(", ") : f; };
export const off = (p) => (p.compare_price > p.price ? Math.round((1 - p.price / p.compare_price) * 100) : 0);
